import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.Components.Compound.ImageHeaderSubtext = createReactClass({
  propTypes() {
    return {
      image: PropTypes.element.isRequired,
      header: PropTypes.string,
      subtext: PropTypes.string,
      url: PropTypes.string
    };
  },
  getDefaultProps() {
    return {
      header: 'Hello, world!',
      subtext: 'Hello, world!'
    };
  },
  render() {
    let header = null;
    let image = null;
    if (this.props.url) {
      header = /*#__PURE__*/_jsxs("a", {
        href: this.props.url,
        className: "h4 Media-heading",
        children: [" ", this.props.header, " "]
      });
      image = /*#__PURE__*/_jsxs("a", {
        href: this.props.url,
        className: "pull-left",
        children: [" ", this.props.image, " "]
      });
    } else {
      header = /*#__PURE__*/_jsxs("span", {
        className: "h4 media-heading",
        children: [" ", this.props.header, " "]
      });
      ({
        image
      } = this.props);
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "Media",
      children: [/*#__PURE__*/_jsx("div", {
        className: "Media--left Media--middle",
        children: image
      }), /*#__PURE__*/_jsxs("div", {
        className: "Media-body Media--middle u-taLeft",
        children: [header, /*#__PURE__*/_jsxs("span", {
          className: "u-tcGray",
          children: [" ", this.props.subtext]
        })]
      })]
    });
  },
  displayName: "ImageHeaderSubtext"
});
window._jsx = _jsx;
window._jsxs = _jsxs;